import { Navigate } from 'react-router-dom';
import React, { useState, useEffect } from 'react';

const ProtectedRoute = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchUser = async () => {
      try {
        const res = await fetch(`${process.env.REACT_APP_BASE_URL}/usersweb/me`, {
          method: 'GET',
           headers: {
          'Content-Type': 'application/json',
          'Authorization': "Bearer " + localStorage.getItem("token")
        },
       
        });

        if (!res.ok) {
          throw new Error('Tidak bisa mengambil data user');
        }

        const data = await res.json();
        console.log('Data user:', data);
        setUser(data.data);
      } catch (err) {
        console.error('Gagal ambil user:', err.message);
        setUser(null);
      } finally {
        setLoading(false);
      }
    };

    fetchUser();
  }, []); // <-- hanya panggil sekali saat komponen pertama kali di-render

  if (loading) return <div>Loading...</div>; // bisa pakai spinner

  if (!user) return <Navigate to="/login" replace />;
   if (!user.akses) {
    return <Navigate to="/login" replace />
        
        }

  return children;
};

export default ProtectedRoute;
